import { Routes, Route, Navigate } from 'react-router-dom';
import { UserRoleProvider } from './hooks/useUserRoles';
import { HelpContextProvider } from './components/help/HelpContextProvider';
import { AppPortalLayout } from './components/layout/AppPortalLayout';
import { Dashboard } from './pages/Dashboard';
import { PriPlusRedirect } from './pages/PriPlusRedirect';
import { FactPlusRedirect } from './pages/FactPlusRedirect';
import { Settings } from './pages/Settings';
import { Users } from './pages/Users';

function App() {
  return (
    <UserRoleProvider>
      <HelpContextProvider>
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
          <Routes>
            <Route path="/" element={<AppPortalLayout />}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              
              {/* Module redirects */}
              <Route path="pri-plus/*" element={<PriPlusRedirect />} />
              <Route path="fact-plus/*" element={<FactPlusRedirect />} />
              
              {/* Admin routes */}
              <Route path="users" element={<Users />} />
              
              {/* Settings */}
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </div>
      </HelpContextProvider>
    </UserRoleProvider>
  );
}

export default App;
